"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApListItem = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApListItem = function (_a) {
    var className = _a.className, children = _a.children, flexDirection = _a.flexDirection, justifyContent = _a.justifyContent, left = _a.left, right = _a.right;
    return (React.createElement(styles_1.StyledListItem, { flexDirection: flexDirection, justifyContent: justifyContent, className: "ap-list-item " + (className ? className : '') },
        left && (React.createElement(styles_1.StyledItemLeftChild, { className: "ap-list-item-left-child" }, left())),
        right && (React.createElement(styles_1.StyledItemRightChild, { className: "ap-list-item-right-child", flexDirection: flexDirection }, right())),
        !left && !right && (React.createElement(styles_1.StyledItemChild, { className: "ap-list-item-child" }, children))));
};
exports.ApListItem.defaultProps = {
    flexDirection: 'row',
    justifyContent: 'space-between'
};
//# sourceMappingURL=ApListItem.js.map